<div class="provider-stats-cards" *ngIf="stats">
  <button class="stat-item" type="button" (click)="goTo('passed')">
    <div class="stat-item__top">
      <ion-icon name="checkmark-circle-outline" aria-hidden="true"></ion-icon>
      <span>{{ "PROVIDER.STATS.FINISHED" | translate }}</span>
    </div>
    <span class="stat-item__count">({{ stats.finished ?? 0 }})</span>
  </button>

  <button class="stat-item" type="button" (click)="goTo('canceled')">
    <div class="stat-item__top">
      <ion-icon name="close-circle-outline" aria-hidden="true"></ion-icon>
      <span>{{ "PROVIDER.STATS.CANCELED" | translate }}</span>
    </div>
    <span class="stat-item__count">({{ stats.canceled ?? 0 }})</span>
  </button>

  <button class="stat-item" type="button" (click)="goTo('suivi')">
    <div class="stat-item__top">
      <ion-icon name="time-outline" aria-hidden="true"></ion-icon>
      <span>{{ "PROVIDER.STATS.INPROGRESS" | translate }}</span>
    </div>
    <span class="stat-item__count">({{ stats.inprogress ?? 0 }})</span>
  </button>
</div>
